export default __webpack_public_path__ + "static/media/webinar-cartoon.7224b7d7.png";